import React from 'react';
import { stats } from '../data/mockData';

const LogoCloud = () => {
  return (
    <section className="py-12 sm:py-16 px-3 sm:px-4 bg-white border-t border-gray-100 overflow-hidden">
      <div className="max-w-6xl mx-auto">
        {/* Title */}
        <h2 className="text-xl sm:text-3xl md:text-4xl font-bold text-gray-900 text-center mb-8 sm:mb-12">
          Loved and trusted by<br />
          <span className="text-[#25D366]">3.5K+ businesses</span>, across the globe
        </h2>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-8 mb-8 sm:mb-12">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <p className="text-2xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-1">
                {stat.value}
              </p>
              <p className="text-gray-500 text-xs sm:text-sm">— {stat.label}</p>
            </div>
          ))}
        </div>

        {/* Logo placeholders */}
        <div className="flex flex-wrap justify-center items-center gap-4 sm:gap-8 md:gap-16 opacity-50">
          <div className="h-6 sm:h-8 w-16 sm:w-24 bg-gray-300 rounded"></div>
          <div className="h-6 sm:h-8 w-20 sm:w-28 bg-gray-300 rounded"></div>
          <div className="h-6 sm:h-8 w-14 sm:w-20 bg-gray-300 rounded"></div>
          <div className="h-6 sm:h-8 w-20 sm:w-32 bg-gray-300 rounded"></div>
          <div className="h-6 sm:h-8 w-16 sm:w-24 bg-gray-300 rounded"></div>
        </div>
      </div>
    </section>
  );
};

export default LogoCloud;
